
<div class="content position-relative">
  <div class="d-flex pb-2 pt-2">
    <div class="w-10">
      <img (click)="backToDashboard()" class="float-left" src="assets/icons/chevron_left_gray_24dp.svg">
    </div>
    <div class="d-flex justify-content-center w-80">
      <img src="assets/icons/add_blue_24dp.svg">
      @if (normalReport) {
        @if (formType=='create') {
          <span class="fw-bold">{{'fieldReporting.report.newInstallation' | translate}}</span>
        }
        @if (formType=='edit') {
          <span class="fw-bold">{{'fieldReporting.report.editInstallation' | translate}}</span>
        }
      }
      @if (!normalReport) {
        <span class="fw-bold">{{'fieldReporting.report.checkingReport' | translate}}</span>
      }
    </div>
  </div>
  @if (normalReport) {
    <div class="row content">
      <hr>
        <div class="p-4">
          <div class="fw-bold">
            @if (isBaseReport) {
              <span>
                {{'planner.routePlanning.base' | translate}}@if (baseIdentifier) {
                : {{ baseIdentifier }}
              }
              #{{ this.id }}
            </span>
          } @else {
            @if (customerId === 4 && workorderData) {
              <span>{{'basic.workorder' | translate}} {{this.workorderData.identifier}}</span>
            }
            @if (customerId !== 2 && customerId !== 4) {
              <span>{{'basic.workorder' | translate}} {{ this.id}}</span>
            }
            @if (customerId === 2) {
              <span>
                @if (workorderData) {
                  <span>{{workorderData.transformer}} - {{workorderData.inverter}}@if (workorderData.circuit) {
                    <span> - {{workorderData.circuit}}</span>
                  }</span>
                }
                @if (!workorderData) {
                  <span>{{'basic.workorder' | translate}} {{ this.id}}</span>
                }
              </span>
            }
          }
        </div>
      </div>
      <hr>
        @if (!isBaseReport) {
          <div>
            <div class="p-4">
              <div class="fw-bold">{{'fieldReporting.report.installationDone' | translate}}</div>
              <div class="d-flex">
                <div class="col-6 ">
                  <button id="yes-button" class="btn w-90"
                    [ngClass]="clickedButtonId === 1 ? 'btn-primary' : 'btn-secondary'"
                    (click)="changeButtonId(1)"
                  [disabled]="loading">{{'basic.yes' | translate}}</button>
                </div>
                <div class="col-6">
                  <button id="no-button" class="btn w-90"
                    [ngClass]="clickedButtonId === 2 ? 'btn-danger' : 'btn-secondary'"
                    (click)="changeButtonId(2)"
                  [disabled]="loading">{{'basic.no' | translate}}</button>
                </div>
              </div>
            </div>
            @if (clickedButtonId === 2) {
              <hr>
              }
              @if (clickedButtonId === 2) {
                <div class="p-4">
                  <div class="fw-bold">
                    {{'basic.reasonForInterruption' | translate}}
                    @if (isMandatory) {
                      <span>*</span>
                    }
                    @if (isOptional) {
                      <span>{{'basic.optional' | translate}}</span>
                    }
                  </div>
                  <textarea type="text" rows="4" class="form-control"
                    placeholder="{{'basic.reasonForInterruptionText' | translate}}" [(ngModel)]="interruptReason"
                    [disabled]="!textareaEnabled">
                  </textarea>
                </div>
              }
              @if (clickedButtonId === 1) {
                <div class="p-4">
                  <div class="fw-bold">{{'fieldReporting.report.deviation' | translate}}</div>
                  <div class="d-flex">
                    <div class="col-6">
                      <button id="no-button2" class="btn w-90"
                        [ngClass]="clickedButton2Id === 2 ? 'btn-primary' : 'btn-secondary'"
                      (click)="changeButton2Id(2)">{{'basic.no' | translate}}</button>
                    </div>
                    <div class="col-6">
                      <button id="yes-button2" class="btn w-90"
                        [ngClass]="clickedButton2Id === 1 ? 'btn-danger' : 'btn-secondary'"
                      (click)="changeButton2Id(1)">{{'basic.yes' | translate}}</button>
                    </div>
                  </div>
                  <div class="fw-bold">{{'basic.notes' | translate}} {{'basic.optional' | translate}}</div>
                  <div class="d-flex">
                    <div class="col-12">
                      <textarea type="text" rows="4" class="form-control"
                        placeholder="{{'basic.notes' | translate}}" [(ngModel)]="notes">
                      </textarea>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @if (isBaseReport) {
            <div class="p-4">
              <h5>Name</h5>
              <input [(ngModel)]="name" class="form-control">
              <h5>Comment</h5>
              <textarea [(ngModel)]="notes" class="form-control" rows="3"></textarea>
            </div>
          }
          @if (clickedButtonId === 2 || clickedButtonId === 1 || isBaseReport) {
            <div class="card-body">
              <div class="w-100" [style.opacity]="(interruptCode !== null || clickedButtonId === 1) ? '1' : '0.5'">
                <div class="w-100 d-flex cursor-pointer" (click)="imgInput.click()">
                  <img src="assets/icons/kamera_blue.svg" class="w-20 camera-icon">
                  <p class="w-70 camera-text small">
                    {{'basic.clickToTakePicture' | translate}}
                    @if (imageMandatory) {
                      <span>*</span>
                    }
                    @if (imageOptional) {
                      <span>{{'basic.optional' | translate}}</span>
                    }
                  </p>
                  <input #imgInput type="file" accept="image/*" (change)="handleImageUpload($event)"
                    style="display:none;" />
                </div>
                <!-- Display all image thumbnails -->
                @for (image of images; track $index) {
                  <div>
                    <img class="thumbnail-img" [src]="image.img" height="50">
                  </div>
                }
                <!-- Warning for missing images -->
                @if (images.length === 0 && firstTabImgCheck) {
                  <div class="red-text">
                    {{'fieldReporting.report.missingImage' | translate}}
                  </div>
                }
              </div>
            </div>
          }
          @if (isBaseReport) {
            <div>
              <button type="button"
                class="btn btn-primary w-90 ms-5-percent mt-2"
                [disabled]="!canSave()"
                (click)="saveReport(formType)">
                {{ formType === 'create'
                ? ('fieldReporting.wiringReport.saveReport' | translate)
                : ('fieldReporting.wiringReport.saveEditReport' | translate)
                }}
              </button>
            </div>
          } @else {
            <div class="d-flex justify-content-center background-light p-4 w-100">
              @if (formType=='create') {
                <button type="button" class="btn btn-primary w-90" [disabled]="!canSave()" (click)="saveReport(formType)">
                  {{'fieldReporting.wiringReport.saveReport' | translate}}
                </button>
              }
              @if (formType=='edit') {
                <button type="button" class="btn btn-primary w-90" [disabled]="!canSave()" (click)="saveReport(formType)">
                  {{'fieldReporting.wiringReport.saveEditReport' | translate}}
                </button>
              }
            </div>
          }
          @if (isBaseReport) {
            <div class="p-4">
              <h5>Prior reports</h5>
              @for (baseReport of baseReports; track $index) {
                <div class="bg-white p-1">
                  @if (baseReport.show === false) {
                    <div class="cursor-pointer d-flex align-items-center">
                      <span>{{baseReport.name}} - {{baseReport.created | date: 'dd.MM.yyyy HH:mm'}}</span>
                      <button class="btn btn-secondary btn-sm ms-2" (click)="baseReport.show = true">Open</button>
                    </div>
                  }
                  @if (baseReport.show === true) {
                    <div>
                      <div>Name: {{baseReport.name}}</div>
                      <div>Comment: {{baseReport.notes}}</div>
                      @if (baseReport.images.length > 0) {
                        <div>Images: </div>
                      }
                      @for (image of baseReport.images; track $index) {
                        <div>
                          <img [src]="image.img" height="50" (click)="this.currentImg = image; openInModal(content)">
                        </div>
                      }
                      <button class="btn btn-primary btn-sm" (click)="baseReport.show = false">Close</button>
                    </div>
                  }
                  <hr>
                  </div>
                }
                <ng-template #content let-modal>
                  <img [src]="currentImg.img" />
                  <button class="btn btn-primary" (click)="closeModal()">Close</button>
                </ng-template>
              </div>
            }
          </div>
        }

        @if (!normalReport) {
          <div>
            <hr>
              <div class="d-flex flex-column align-items-center w-100">
                <h4 class="text-center mb-3">Piling done</h4>
                <div class="d-flex justify-content-center w-100">
                  <button type="button" class="btn mx-3 px-4 flex-grow-1" (click)="pilingDone = true" [ngClass]="pilingDone === true ? 'btn-primary' : 'btn-secondary'">Yes</button>
                  <button type="button" class="btn mx-3 px-4 flex-grow-1" (click)="pilingDone = false; frameAssemblyDone = null; panelInstallationDone = null" [ngClass]="pilingDone === false ? 'btn-primary' : 'btn-secondary'">No</button>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center w-100">
                <h4 class="text-center mb-3 mt-3">Frame assembly done</h4>
                <div class="d-flex justify-content-center w-100">
                  <button type="button" class="btn mx-3 px-4 flex-grow-1" [disabled]="pilingDone === false || pilingDone === null" (click)="frameAssemblyDone = true" [ngClass]="frameAssemblyDone === true ? 'btn-primary' : 'btn-secondary'">Yes</button>
                  <button type="button" class="btn mx-3 px-4 flex-grow-1" [disabled]="pilingDone === false || pilingDone === null" (click)="frameAssemblyDone = false; panelInstallationDone = null" [ngClass]="frameAssemblyDone === false ? 'btn-primary' : 'btn-secondary'">No</button>
                </div>
              </div>
              <div class="d-flex flex-column align-items-center w-100">
                <h4 class="text-center mb-3 mt-3">Panel installation done</h4>
                <div class="d-flex justify-content-center w-100">
                  <button type="button" class="btn mx-3 px-4 flex-grow-1" [disabled]="pilingDone === false || pilingDone === null || frameAssemblyDone === false || frameAssemblyDone === null" (click)="panelInstallationDone = true" [ngClass]="panelInstallationDone === true ? 'btn-primary' : 'btn-secondary'">Yes</button>
                  <button type="button" class="btn mx-3 px-4 flex-grow-1" [disabled]="pilingDone === false || pilingDone === null || frameAssemblyDone === false || frameAssemblyDone === null" (click)="panelInstallationDone = false" [ngClass]="panelInstallationDone === false ? 'btn-primary' : 'btn-secondary'">No</button>
                </div>
              </div>
              <h4 class="text-center mt-3">Notes</h4>
              <div class="d-flex justify-content-center">
                <textarea class="form-control w-80" [(ngModel)]="type3Notes"></textarea>
              </div>
              <div class="card-body mt-3">
                <div class="w-100">
                  <div class="w-100 d-flex cursor-pointer" (click)="imgInput.click()">
                    <img src="assets/icons/kamera_blue.svg" class="w-20 camera-icon">
                    <p class="w-70 camera-text small">
                      {{'basic.clickToTakePicture' | translate}}
                      @if (imageMandatory) {
                        <span>*</span>
                      }
                      @if (imageOptional) {
                        <span>{{'basic.optional' | translate}}</span>
                      }
                    </p>
                    <input #imgInput type="file" accept="image/*" (change)="handleImageUpload($event)"
                      style="display:none;" />
                  </div>
                  <!-- Display all image thumbnails -->
                  @for (image of images; track $index) {
                    <div>
                      <img class="thumbnail-img" [src]="image.img" height="50">
                    </div>
                  }
                  <!-- Warning for missing images -->
                  @if (images.length === 0 && firstTabImgCheck) {
                    <div class="red-text">
                      {{'fieldReporting.report.missingImage' | translate}}
                    </div>
                  }
                </div>
              </div>
              <hr>
                <div class="d-flex flex-column align-items-center w-100">
                  <div class="d-flex justify-content-center w-100 mb-3">
                    <button type="button" class="btn btn-primary mx-3 px-4 flex-grow-1" (click)="saveReportType3()">Save</button>
                    <button type="button" class="btn btn-secondary mx-3 px-4 flex-grow-1" (click)="backToDashboard()">Quit</button>
                  </div>
                </div>
              </div>
            }
          </div>
